import { useNavigate } from 'react-router'
import styled from 'styled-components'
import { UserRole } from '../../models/User'
import { useAppDispatch } from '../../store'
import {
  asyncSignup,
  resetApiResult,
  SignUpFormValues,
  UserState,
} from '../../store/userSlice'
import SignUpForm from '../Popup/SignUpForm'

function Main() {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const onSignUp = async (values: SignUpFormValues) => {
    dispatch(resetApiResult())
    const us = await dispatch(asyncSignup(values))

    const uss: UserState = us.payload as UserState
    navigate(uss.me.userRole == UserRole.MENTEE ? '/mentee' : '/mentor')
  }

  return (
    <Container>
      <Section1>
        <div>
          <div>나와 딱 맞는 직업을 찾아가는 여정에 오르세요</div>
          <div>
            일생동안 즐겁게 일할 수 있는 나에게 맞는 직업은 <br />
            한번의 테스트와 경험으로 만들어지지 않습니다.
          </div>
        </div>
        {/* <SignupWrap> <SignUpForm onSignUp={onSignUp} /></SignupWrap> */}
      </Section1>
      <Section1>
        <div>성향과 지향에 따라 직업을 추천해드립니다.</div>
        <div>
          나는 어떤 사람인지, 어떤 것을 좋아하고 어떤 것을 싫어하는지 지속적으로
          체크합니다. 그리고 그것에 따라 변해가는 나의 직업관에 따라 적합한
          직업이 어떻게 변해가는지 확인 할 수 있습니다.
        </div>
        <img src={`${process.env.PUBLIC_URL}/images/mockup/section1.jpg`} />
      </Section1>
      <Section1>
        <div>직업 인벤토리로 나에게 맞는 직업들의 공통점을 찾아보세요.</div>
        <div>
          내가 선택한 직업들 사이에는 내가 알지 못했던 공통점이 있습니다. 그
          공통점을 통해 내가 원하는 것이 무엇인지 알 수 있습니다. 나와 비슷한
          직업을 가진 사람들이 나와 다른 어떤 직업을 가지고 있는지도
          확인해보세요.
        </div>
        <img src="/images/mockup/section2.jpg" />
      </Section1>
    </Container>
  )
}

const Container = styled.div`
  grid-area: main;
  margin-bottom: 5rem;
  //padding-top: 3rem;
`
const SignupWrap = styled.div`
  background-color: var(--point-color3);
  padding: 20px;
`

const Section1 = styled.div`
  padding: 0px 0;

  div:first-child {
    font-size: 1.5rem;
    color: var(--black-font);
    padding: 3rem 0 2rem;
  }
  div:nth-child(2) {
    font-size: 1.1rem;
    padding-bottom: 1rem;
    color: var(--darkgray-font);
  }
  img {
    width: 100%;
  }
`
const Section2 = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 40px;
  row-gap: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
  }

  div:nth-child(1) {
    flex-basis: 300px;
    flex-grow: 5;

    div:first-child {
      font-size: 1.5rem;
      color: var(--black-font);
      text-align: right;
      padding: 3rem 0;
    }
    div:nth-child(2) {
      font-size: 1.2rem;
      color: var(--darkgray-font);
      text-align: right;
    }
  }
  div:nth-child(2) {
    flex-basis: 200px;
    flex-grow: 2;
  }
`
export default Main
